import { Factory } from '../../services/Factory';

import IAugmentedJQuery = angular.IAugmentedJQuery;

export interface INumberSpinnerAttributes extends angular.IAttributes {
  step: string;
}

export class NumberSpinner implements angular.IDirective {
  public restrict: string = 'A';
  public require: string = 'ngModel';
  public link: (
    scope: angular.IScope,
    element: IAugmentedJQuery,
    attrs: INumberSpinnerAttributes,
    ngModel: angular.INgModelController
  ) => void;

  constructor() {
    this.link = (scope, element, attrs, ngModel) => {
      const step = parseFloat(attrs.step) || 1;

      const applyStep = (direction: number) => {
        const current = parseFloat(ngModel.$viewValue) || 0;
        ngModel.$setViewValue(String(current + direction * step));
        ngModel.$render();
        scope.$apply();
      };

      // Native number-input spin buttons repeat continuously on a single click in this
      // Angular context (fixed on the React side by replacing them outright - see SpinnerInput).
      // Custom buttons + preventDefault on mousedown (stops focus theft, which is what triggers
      // the repeat) give a single, predictable step per click instead.
      const buttons = angular.element(
        '<span class="iio-number-spinner-buttons">' +
          '<button type="button" tabindex="-1" class="iio-number-spinner-btn iio-number-spinner-btn-up"><i class="fas fa-caret-up"></i></button>' +
          '<button type="button" tabindex="-1" class="iio-number-spinner-btn iio-number-spinner-btn-down"><i class="fas fa-caret-down"></i></button>' +
        '</span>'
      );

      buttons
        .find('.iio-number-spinner-btn-up')
        .on('mousedown', (event: Event) => event.preventDefault())
        .on('click', () => applyStep(1));

      buttons
        .find('.iio-number-spinner-btn-down')
        .on('mousedown', (event: Event) => event.preventDefault())
        .on('click', () => applyStep(-1));

      element.addClass('iio-number-spinner-input');
      element.wrap('<div class="iio-number-spinner"></div>');
      element.after(buttons);
    };
  }
}

frontendApp.directive('iioNumberSpinner', [Factory.Create(NumberSpinner)]);
